import { render, staticRenderFns } from "./RomaCoverage.vue?vue&type=template&id=5be3991c"
import script from "./RomaCoverage.vue?vue&type=script&lang=ts"
export * from "./RomaCoverage.vue?vue&type=script&lang=ts"
import style0 from "./RomaCoverage.vue?vue&type=style&index=0&id=5be3991c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports